import { BigNumber, ethers, Signer } from "ethers";
import UserWalletAbi from "./abi/UserWallet";

export interface IBalanceResponse {
    balance: BigNumber;
    natural: string;
}

class WalletProxy {
    signer: Signer;
    address: string;
    instance: ethers.Contract;

    constructor(address: string, signer: Signer) {
        this.address = address;
        this.signer = signer;
        this.instance = new ethers.Contract(address, UserWalletAbi, signer);
    }

    public getBalance = async (): Promise<IBalanceResponse> => {
        const balance = await this.signer.getBalance(this.address);
        const natural = ethers.utils.formatEther(balance)
        return { balance, natural };
    }
}

export default WalletProxy;
